/**
 * Mock-Daten für den AI-Agents-Bereich (Agent-as-a-Service).
 * Nur Frontend — später durch API ersetzen.
 */

export const SERVICES = [
  {
    id: "legal_review",
    slug: "legal_review",
    icon: "\u2696",
    name: "Juristische Pr\u00fcfung",
    domain: "Recht",
    owner: "Hassan",
    version: "v2.1",
    status: "stable",
    health: 3,
    stats: { p95_ms: 2100, success: 0.982, calls_24h: 1200 },
    contract: {
      input_schema: {
        type: "object",
        required: ["document_text", "jurisdiction"],
        properties: {
          document_text: { type: "string" },
          jurisdiction: { type: "string", enum: ["DE", "AT", "CH"] },
          document_type: { type: "string" },
        },
      },
      output_schema: {
        type: "object",
        required: ["risk_score", "findings"],
        properties: {
          risk_score: { type: "number", minimum: 0, maximum: 1 },
          findings: { type: "array", items: { type: "string" } },
          recommendations: { type: "array", items: { type: "string" } },
          confidence: { type: "number" },
        },
      },
      example_request: {
        document_text: "AGB Klausel 7.2 Haftungsausschluss...",
        jurisdiction: "DE",
        document_type: "AGB",
      },
      example_response: {
        risk_score: 0.34,
        findings: ["\u00a7 309 BGB pr\u00fcfen", "Widerrufsbelehrung vollst\u00e4ndig"],
        recommendations: ["Klausel umformulieren", "Rechtsberatung einholen"],
        confidence: 0.91,
      },
    },
    brain: {
      sysprompt:
        "Du bist ein juristischer Pr\u00fcfungs-Assistent f\u00fcr Verbraucherrecht. Gib keine abschlie\u00dfende Rechtsberatung. Zitiere nur publizierte Normen. Antworte strukturiert mit risk_score 0\u20131.",
      model: "claude-opus-4.6",
      thinking_budget: 4000,
    },
    tools: ["search_caselaw", "lookup_paragraph", "compare_contracts"],
    knowledge: [
      {
        name: "BGB/HGB Vektor-DB",
        chunks: 12400,
        last_index: "2026-04-28 08:00",
      },
      {
        name: "Mustervertr\u00e4ge intern",
        chunks: 890,
        last_index: "2026-04-27 14:20",
      },
    ],
    versions: [
      {
        v: "v2.1",
        status: "stable",
        traffic: 80,
        changelog: "Striktere Zitationspflicht, Tool lookup_paragraph stabilisiert",
      },
      {
        v: "v2.0",
        status: "stable",
        traffic: 20,
        changelog: "Neues Output-Schema mit confidence",
      },
      { v: "v1.9", status: "deprecated", traffic: 0, changelog: "EOL 2026-05-01" },
    ],
    endpoints: {
      mcp: "mcp://legal.aimafia.de/mcp",
      a2a: "https://ws.aimafia.de/api/agent/a2a/legal_review",
      rest: "https://ws.aimafia.de/api/agent/v1/legal_review",
    },
    consumer_ids: ["telefonio", "backoffice", "compliance_partner"],
    recent_runs: [
      {
        id: "run_a8f3",
        status: "success",
        at: "14:32:08",
        caller: "Telefonio",
        latency_ms: 1840,
        tokens: 1200,
      },
      {
        id: "run_b1x2",
        status: "success",
        at: "14:28:11",
        caller: "Backoffice",
        latency_ms: 2400,
        tokens: 1900,
      },
      {
        id: "run_c9zz",
        status: "error",
        at: "14:21:44",
        caller: "Telefonio",
        latency_ms: 5000,
        tokens: 0,
      },
    ],
  },
  {
    id: "financial_audit",
    slug: "financial_audit",
    icon: "\u{1F4B6}",
    name: "Finanz-Audit",
    domain: "Finanzen",
    owner: "Masih",
    version: "v1.0",
    status: "beta",
    health: 2,
    stats: { p95_ms: 4800, success: 0.91, calls_24h: 340 },
    contract: {
      input_schema: {
        type: "object",
        required: ["financials_csv", "period"],
        properties: {
          financials_csv: { type: "string" },
          period: { type: "string" },
          kpi_focus: { type: "array", items: { type: "string" } },
        },
      },
      output_schema: {
        type: "object",
        properties: {
          flags: { type: "array" },
          variance_analysis: { type: "string" },
          ratios: { type: "object" },
          narrative: { type: "string" },
        },
      },
      example_request: {
        financials_csv: "konto,betrag\numsatz,120000\n...",
        period: "Q3-2025",
        kpi_focus: ["liquiditaet", "verschuldung"],
      },
      example_response: {
        flags: ["Cashflow-Differenz > 15%"],
        variance_analysis: "Umsatz +8% YoY, Wareneinsatz +22%",
        ratios: { current_ratio: 1.4, debt_to_equity: 0.62 },
        narrative: "Kurzfassung f\u00fcr Vorstand...",
      },
    },
    brain: {
      sysprompt:
        "Du analysierst Jahresabschlussdaten und Kennzahlen. Kennzeichne Unsicherheiten. Keine Anlageberatung.",
      model: "claude-sonnet-4.5",
      thinking_budget: 8000,
    },
    tools: ["compute_ratios", "benchmark_industry", "query_dataroom"],
    knowledge: [
      {
        name: "HGB Bilanzregeln",
        chunks: 5600,
        last_index: "2026-04-26 10:00",
      },
      {
        name: "Branchenbenchmarks DE",
        chunks: 2100,
        last_index: "2026-04-20 09:15",
      },
    ],
    versions: [
      {
        v: "v1.0",
        status: "beta",
        traffic: 100,
        changelog: "Erste Beta mit Ratios + Narrative",
      },
      {
        v: "v0.9",
        status: "deprecated",
        traffic: 0,
        changelog: "Nur interne Tests",
      },
    ],
    endpoints: {
      mcp: "mcp://finance.aimafia.de/mcp",
      a2a: "https://ws.aimafia.de/api/agent/a2a/financial_audit",
      rest: "https://ws.aimafia.de/api/agent/v1/financial_audit",
    },
    consumer_ids: ["backoffice", "telefonio"],
    recent_runs: [
      {
        id: "run_fin1",
        status: "pending",
        at: "14:31:55",
        caller: "Backoffice",
        latency_ms: null,
        tokens: null,
      },
    ],
  },
  {
    id: "knowledge_answer",
    slug: "knowledge_answer",
    icon: "\u{1F4DA}",
    name: "Knowledge Answerer",
    domain: "Cross",
    owner: "Elias",
    version: "v3.4",
    status: "stable",
    health: 3,
    stats: { p95_ms: 900, success: 0.991, calls_24h: 18400 },
    contract: {
      input_schema: {
        type: "object",
        required: ["question", "audience"],
        properties: {
          question: { type: "string" },
          audience: { type: "string", enum: ["support", "internal", "exec"] },
        },
      },
      output_schema: {
        type: "object",
        properties: {
          answer: { type: "string" },
          citations: { type: "array" },
          confidence: { type: "number" },
        },
      },
      example_request: {
        question: "Wie setze ich Voicemail um?",
        audience: "support",
      },
      example_response: {
        answer: "Unter Einstellungen \u2192 Anruf \u2192...",
        citations: ["kb/voicemail-setup.md#section-2"],
        confidence: 0.96,
      },
    },
    brain: {
      sysprompt:
        "Antworte nur aus der Wissensbasis. Wenn unklar: sage es und schlage Follow-up-Fragen vor.",
      model: "claude-haiku-4.5",
      thinking_budget: 1200,
    },
    tools: ["vector_search", "fetch_doc", "summarize_snippets"],
    knowledge: [
      {
        name: "Produkt-KB",
        chunks: 89000,
        last_index: "2026-04-28 06:00",
      },
      {
        name: "Support-Tickets (embeddings)",
        chunks: 450000,
        last_index: "2026-04-28 05:30",
      },
    ],
    versions: [
      {
        v: "v3.4",
        status: "stable",
        traffic: 95,
        changelog: "Haiku 4.5, geringere Latenz",
      },
      {
        v: "v3.3",
        status: "stable",
        traffic: 5,
        changelog: "Bugfix Citations",
      },
    ],
    endpoints: {
      mcp: "mcp://kb.aimafia.de/mcp",
      a2a: "https://ws.aimafia.de/api/agent/a2a/knowledge_answer",
      rest: "https://ws.aimafia.de/api/agent/v1/knowledge_answer",
    },
    consumer_ids: ["telefonio", "backoffice", "public_api"],
    recent_runs: [
      {
        id: "run_kb1",
        status: "success",
        at: "14:33:01",
        caller: "Telefonio",
        latency_ms: 720,
        tokens: 420,
      },
    ],
  },
  {
    id: "pii_redactor",
    slug: "pii_redactor",
    icon: "\u{1F512}",
    name: "PII-Redaktor",
    domain: "Compliance",
    owner: "Hassan",
    version: "v1.2",
    status: "stable",
    health: 3,
    stats: { p95_ms: 350, success: 0.999, calls_24h: 42000 },
    contract: {
      input_schema: {
        type: "object",
        required: ["text"],
        properties: { text: { type: "string" }, locale: { type: "string" } },
      },
      output_schema: {
        type: "object",
        properties: {
          redacted_text: { type: "string" },
          pii_map: { type: "object" },
        },
      },
      example_request: { text: "Ich bin Max Muster, Tel +49 170 ...", locale: "de" },
      example_response: {
        redacted_text: "Ich bin [NAME], Tel [PHONE]",
        pii_map: { NAME: "Max Muster", PHONE: "+49 170 ..." },
      },
    },
    brain: {
      sysprompt: "Erkenne PII nach DSGVO-relevanten Kategorien. Ersetze konsistent.",
      model: "claude-haiku-4.5",
      thinking_budget: 512,
    },
    tools: ["regex_entities", "ner_model"],
    knowledge: [],
    versions: [
      {
        v: "v1.2",
        status: "stable",
        traffic: 100,
        changelog: "IBAN-Erkennung verbessert",
      },
    ],
    endpoints: {
      mcp: "mcp://compliance.aimafia.de/mcp",
      a2a: "https://ws.aimafia.de/api/agent/a2a/pii_redactor",
      rest: "https://ws.aimafia.de/api/agent/v1/pii_redactor",
    },
    consumer_ids: ["telefonio", "backoffice", "compliance_partner"],
    recent_runs: [],
  },
  {
    id: "contract_bundle",
    slug: "contract_bundle",
    icon: "\u{1F4CB}",
    name: "Vertrags-Komplett-Audit",
    domain: "Recht",
    owner: "Masih",
    version: "v0.5",
    status: "draft",
    health: 1,
    stats: { p95_ms: null, success: null, calls_24h: 12 },
    contract: {
      input_schema: {
        type: "object",
        required: ["documents"],
        properties: {
          documents: { type: "array", items: { type: "string" } },
        },
      },
      output_schema: {
        type: "object",
        properties: {
          legal: { type: "object" },
          finance: { type: "object" },
          merged_report: { type: "string" },
        },
      },
      example_request: { documents: ["vertrag.pdf", "anlage_b.csv"] },
      example_response: {
        legal: { risk_score: 0.4 },
        finance: { flags: [] },
        merged_report: "Zusammenfassung...",
      },
    },
    brain: {
      sysprompt:
        "Orchestriere Sub-Calls zu legal_review und financial_audit. Keine Doppelarbeit.",
      model: "claude-opus-4.6",
      thinking_budget: 12000,
    },
    tools: ["delegate_legal_review", "delegate_financial_audit", "merge_reports"],
    knowledge: [],
    versions: [
      {
        v: "v0.5",
        status: "draft",
        traffic: 100,
        changelog: "Internes Alpha",
      },
    ],
    endpoints: {
      mcp: "mcp://bundle.aimafia.de/mcp",
      a2a: "https://ws.aimafia.de/api/agent/a2a/contract_bundle",
      rest: null,
    },
    consumer_ids: ["backoffice"],
    recent_runs: [],
  },
];

export const CONSUMERS = [
  {
    id: "telefonio",
    kind: "intern",
    icon: "\u{1F916}",
    name: "Telefonio Voice Agent",
    slug: "app:telefonio",
    api_keys_count: 4,
    quota_per_day: 50000,
    services_count: 6,
    last_call: "vor 12s",
    allowed_service_ids: [
      "legal_review",
      "financial_audit",
      "knowledge_answer",
      "pii_redactor",
    ],
    keys: [
      { label: "Prod", masked: "tk_live_...b7f2" },
      { label: "Staging", masked: "tk_test_...c91a" },
    ],
    audit_log: [
      {
        at: "14:30:01",
        action: "key_rotated",
        detail: "Prod-Key rotiert (Masih)",
      },
      { at: "09:12:44", action: "scope_updated", detail: "+ financial_audit" },
    ],
  },
  {
    id: "backoffice",
    kind: "intern",
    icon: "\u{1F4CA}",
    name: "Backoffice CRM",
    slug: "app:backoffice",
    api_keys_count: 1,
    quota_per_day: 10000,
    services_count: 5,
    last_call: "vor 4m",
    allowed_service_ids: [
      "legal_review",
      "financial_audit",
      "knowledge_answer",
      "contract_bundle",
    ],
    keys: [{ label: "Prod", masked: "tk_live_...d400" }],
    audit_log: [
      { at: "13:01:00", action: "login_api", detail: "Healthcheck OK" },
    ],
  },
  {
    id: "compliance_partner",
    kind: "partner",
    icon: "\u{1F91D}",
    name: "Compliance Partner Agent",
    slug: "ext:compliance.partner.de",
    api_keys_count: 1,
    quota_per_day: 1000,
    services_count: 2,
    last_call: "vor 2h",
    allowed_service_ids: ["legal_review", "pii_redactor"],
    keys: [{ label: "Partner", masked: "tk_ptnr_...91aa" }],
    audit_log: [{ at: "11:45:22", action: "rate_limited", detail: "429 burst" }],
  },
  {
    id: "public_api",
    kind: "extern",
    icon: "\u{1F310}",
    name: "Public API (Sandbox)",
    slug: "app:public_sandbox",
    api_keys_count: 2,
    quota_per_day: 500,
    services_count: 1,
    last_call: "vor 1d",
    allowed_service_ids: ["knowledge_answer"],
    keys: [
      { label: "Sandbox", masked: "tk_sbx_...0001" },
      { label: "Demo", masked: "tk_sbx_...0002" },
    ],
    audit_log: [],
  },
];

export const RUNS = [
  {
    id: "run_a8f3c2",
    status: "success",
    service_id: "legal_review",
    version: "v2.1",
    at_label: "14:32:08",
    latency_ms: 1840,
    tokens_in: 820,
    tokens_out: 380,
    cost_eur: 0.018,
    caller_id: "telefonio",
    description: "AGB Mustermann GmbH \u2014 AGB-Check",
    trace: [
      {
        type: "inbound",
        title: "Inbound Request",
        body: '{"document_text":"...","jurisdiction":"DE"}',
      },
      {
        type: "validation",
        title: "Schema-Validation",
        body: "OK \u2014 alle Pflichtfelder gesetzt",
      },
      {
        type: "reasoning",
        title: "Reasoning",
        body: "Ich pr\u00fcfe zuerst \u00a7 305 BGB relevante Klauseln...",
        tokens: 320,
      },
      {
        type: "tool",
        title: "search_caselaw",
        body: 'args: {"paragraph":"305 BGB"}\n\u2192 4 Treffer (180ms)',
      },
      {
        type: "tool",
        title: "lookup_paragraph",
        body: "\u2192 OK (210ms)",
      },
      {
        type: "reasoning",
        title: "Reasoning",
        body: "Treffer best\u00e4tigen Risiko mittel...",
        tokens: 490,
      },
      {
        type: "output",
        title: "Output",
        body: '{"risk_score":0.34,"findings":[...]}',
      },
    ],
  },
  {
    id: "run_b2e9f1",
    status: "pending",
    service_id: "financial_audit",
    version: "v1.0",
    at_label: "14:31:55",
    latency_ms: null,
    tokens_in: 2100,
    tokens_out: null,
    cost_eur: null,
    caller_id: "backoffice",
    description: "Q3-Bilanz NewCo \u2014 risk_score 0.84",
    trace: [
      {
        type: "inbound",
        title: "Inbound Request",
        body: '{"financials_csv":"...","period":"Q3-2025"}',
      },
      {
        type: "reasoning",
        title: "Reasoning",
        body: "Ungew\u00f6hnliche Cashflow-Differenz erkannt...",
        tokens: 1200,
      },
      {
        type: "pending",
        title: "Wartet auf Freigabe",
        body: "Schwellwert risk_score > 0.8 \u2014 Human-in-the-Loop",
      },
    ],
  },
  {
    id: "run_c9zz",
    status: "error",
    service_id: "legal_review",
    version: "v2.1",
    at_label: "14:21:44",
    latency_ms: 5000,
    tokens_in: 400,
    tokens_out: 0,
    cost_eur: 0,
    caller_id: "telefonio",
    description: "Timeout bei search_caselaw",
    trace: [
      { type: "inbound", title: "Inbound Request", body: "..." },
      {
        type: "tool",
        title: "search_caselaw",
        body: "BLOCKED \u2014 > 5sTimeout",
      },
      { type: "output", title: "Fehler", body: "TIMEOUT" },
    ],
  },
  {
    id: "run_d42",
    status: "refused",
    service_id: "pii_redactor",
    version: "v1.2",
    at_label: "13:58:10",
    latency_ms: 45,
    tokens_in: 12,
    tokens_out: 8,
    cost_eur: 0.0001,
    caller_id: "public_api",
    description: "Input \u00fcber Quota",
    trace: [
      { type: "inbound", title: "Inbound Request", body: "..." },
      {
        type: "output",
        title: "Abgelehnt",
        body: "429 \u2014 Tageslimit erreicht",
      },
    ],
  },
  {
    id: "run_orchestrator",
    status: "success",
    service_id: "contract_bundle",
    version: "v0.5",
    at_label: "12:15:33",
    latency_ms: 12400,
    tokens_in: 900,
    tokens_out: 600,
    cost_eur: 0.42,
    caller_id: "backoffice",
    description: "Bundle: Vertrag + Bilanz",
    trace: [
      { type: "inbound", title: "Inbound Request", body: '{"documents":["a.pdf","b.csv"]}' },
      {
        type: "reasoning",
        title: "Orchestrator",
        body: "Delegiere an Sub-Services...",
        tokens: 200,
      },
      {
        type: "nested",
        title: "Sub: legal_review",
        children: [
          {
            type: "tool",
            title: "delegate_legal_review",
            body: "\u2192 risk_score 0.41",
          },
        ],
      },
      {
        type: "nested",
        title: "Sub: financial_audit",
        children: [
          {
            type: "tool",
            title: "delegate_financial_audit",
            body: "\u2192 2 flags",
          },
        ],
      },
      {
        type: "output",
        title: "merge_reports",
        body: "merged_report.md generiert",
      },
    ],
  },
  {
    id: "run_kb_fast",
    status: "success",
    service_id: "knowledge_answer",
    version: "v3.4",
    at_label: "14:33:01",
    latency_ms: 720,
    tokens_in: 200,
    tokens_out: 220,
    cost_eur: 0.002,
    caller_id: "telefonio",
    description: "Voicemail Setup Frage",
    trace: [
      { type: "inbound", title: "Inbound Request", body: "..." },
      {
        type: "tool",
        title: "vector_search",
        body: "\u2192 3 Treffer",
      },
      { type: "output", title: "Output", body: '{"answer":"...","citations":[...]}' },
    ],
  },
];

export const EVAL_SETS = [
  {
    id: "eval_agb",
    name: "AGB-Check Standard",
    service_id: "legal_review",
    datapoints: 120,
    last_run: "heute 09:00",
    current_v: "v2.1",
    current_pct: 94.2,
    prev_v: "v2.0",
    prev_pct: 89.1,
    trend: "up",
    sparkline: [82, 84, 86, 87, 88, 89, 91, 92, 93, 94.2],
    regression: false,
    datapoint_examples: [
      { id: "dp1", label: "Haftungsausschluss Fitnessstudio", pass: true },
      { id: "dp2", label: "Widerruf Elektronik", pass: true },
      { id: "dp3", label: "AGB SaaS B2B", pass: false },
    ],
    run_history: [
      { at: "heute 09:00", score: 94.2, version: "v2.1" },
      { at: "gestern 18:00", score: 93.8, version: "v2.1" },
      { at: "Mo 12:00", score: 89.1, version: "v2.0" },
    ],
    diff_note:
      "v2.1 verbessert Zitation bei \u00a7 305 BGB; v2.0 hatte False Positives bei SaaS-B2B.",
  },
  {
    id: "eval_fin",
    name: "Bilanz-Anomalien Q3",
    service_id: "financial_audit",
    datapoints: 50,
    last_run: "gestern 14:00",
    current_v: "v1.0",
    current_pct: 78.0,
    prev_v: "v0.9",
    prev_pct: 82.4,
    trend: "down",
    sparkline: [84, 83, 82.5, 82.4, 81, 80, 79, 78.5, 78.2, 78.0],
    regression: true,
    datapoint_examples: [
      { id: "f1", label: "Handwerk GmbH", pass: true },
      { id: "f2", label: "NewCo Startup", pass: false },
    ],
    run_history: [
      { at: "gestern 14:00", score: 78.0, version: "v1.0" },
      { at: "letzte Woche", score: 82.4, version: "v0.9" },
    ],
    diff_note:
      "Regression: v1.0 strengere Varianzregeln \u2014 Review Ground Truth n\u00f6tig.",
  },
  {
    id: "eval_kb",
    name: "Support-KB Trefferquote",
    service_id: "knowledge_answer",
    datapoints: 500,
    last_run: "heute 06:00",
    current_v: "v3.4",
    current_pct: 96.8,
    prev_v: "v3.3",
    prev_pct: 95.1,
    trend: "up",
    sparkline: [93, 93.5, 94, 94.5, 95.1, 95.4, 96, 96.5, 96.7, 96.8],
    regression: false,
    datapoint_examples: [],
    run_history: [{ at: "heute 06:00", score: 96.8, version: "v3.4" }],
    diff_note: "Haiku 4.5 reduziert Halluzinationen bei kurzen Fragen.",
  },
];

export const COSTS = [
  {
    id: "cost_kb",
    service_id: "knowledge_answer",
    calls_24h: 18400,
    tokens_24h: 4_200_000,
    eur_24h: 92.6,
    budget_eur_day: 150,
  },
  {
    id: "cost_legal",
    service_id: "legal_review",
    calls_24h: 1200,
    tokens_24h: 890_000,
    eur_24h: 24.3,
    budget_eur_day: 80,
  },
  {
    id: "cost_fin",
    service_id: "financial_audit",
    calls_24h: 340,
    tokens_24h: 1_100_000,
    eur_24h: 38.1,
    budget_eur_day: 50,
  },
  {
    id: "cost_pii",
    service_id: "pii_redactor",
    calls_24h: 42000,
    tokens_24h: 2_100_000,
    eur_24h: 11.2,
    budget_eur_day: 40,
  },
];

export const APPROVALS = [
  {
    id: "appr_1",
    run_id: "run_b2e9f1",
    service_id: "financial_audit",
    caller_id: "backoffice",
    risk_score: 0.84,
    summary: "Q3-Bilanz NewCo: ungew\u00f6hnliche Cashflow-Differenz",
    pending_since: "vor 4 Min",
    justification_placeholder:
      "Interne Notiz f\u00fcr Freigabe oder Ablehnung (Mock)",
  },
  {
    id: "appr_2",
    run_id: "run_x99",
    service_id: "legal_review",
    caller_id: "telefonio",
    risk_score: 0.71,
    summary: "Verbrauchervertrag \u2014 unklare Widerrufsbelehrung",
    pending_since: "vor 18 Min",
    justification_placeholder: "",
  },
];

export const INCIDENTS = [
  {
    id: "inc_1",
    service_id: "legal_review",
    version: "v2.1",
    title: "Falsche Zitation in 14 Calls",
    severity: "medium",
    opened_at: "vor 2h",
    affected_calls: 14,
    description:
      "Modell zitierte nicht-existierende Randnummern in 3% der F\u00e4lle. Mitigation: Prompt-H\u00e4rte + Eval-Gate.",
    owner: "Hassan",
  },
];

/** Tab „\u00dcbersicht“: Schichtenmodell (Gate \u2192 \u2026 \u2192 Data) vs. Admin-Tabs (Mockup). */
export const PLATFORM_OVERVIEW_ROWS = [
  {
    id: "gate",
    short_en: "Gate",
    name_de: "Zugang",
    blurb:
      "Alles von au\u00dfen: TLS, Raten, Webhooks, API-Keys und erlaubte Scopes pro Client.",
    admin_tab: "Clients",
  },
  {
    id: "agent",
    short_en: "Agent",
    name_de: "KI",
    blurb:
      "Lauf, Sysprompt, Modellwahl, Contract Ein-/Ausgabe \u2014 was die Plattform dem Modell erlaubt.",
    admin_tab: "Agents",
  },
  {
    id: "tools",
    short_en: "Tools",
    name_de: "Werkzeuge",
    blurb:
      "Katalog: Namen, Parameter, Versionen \u2014 die kontrollierte Br\u00fccke nach au\u00dfen f\u00fcr das Modell.",
    admin_tab: "Tools",
  },
  {
    id: "action",
    short_en: "Action",
    name_de: "Umsetzung",
    blurb:
      "Ausf\u00fchrung hinter den Tools: HTTP, Worker, Timeouts, Sandbox \u2014 sichtbar in Traces.",
    admin_tab: "Actions",
  },
  {
    id: "data",
    short_en: "Data",
    name_de: "Daten",
    blurb:
      "Speicher und Indizes (DB, Dateien, Vektor); Retention und Scope pro Speicher.",
    admin_tab: "Data",
  },
  {
    id: "cross_obs",
    short_en: "\u2014",
    name_de: "Beobachtung",
    blurb: "Laufzeiten, Token, Traces, Fehler.",
    admin_tab: "Aufrufe",
  },
  {
    id: "cross_quality",
    short_en: "\u2014",
    name_de: "Qualit\u00e4t",
    blurb: "Regressionstests, Golden Sets, Modell-/Prompt-Vergleich.",
    admin_tab: "Evals",
  },
  {
    id: "cross_gov",
    short_en: "\u2014",
    name_de: "Governance",
    blurb: "Budgets, Freigaben, Vorf\u00e4lle, Richtlinien.",
    admin_tab: "Governance",
  },
];

/** Tools (Werkzeug-Katalog): was Agents aufrufen d\u00fcrfen. Mockup. */
export const TOOLS = [
  {
    id: "tool_search_caselaw",
    slug: "search_caselaw",
    name: "Rechtsprechung suchen",
    description:
      "Sucht in der internen Caselaw-DB nach passenden Urteilen zu einem Paragraphen.",
    category: "Recht",
    version: "v1.4",
    status: "stable",
    params: { paragraph: "string", jurisdiction: "DE|AT|CH" },
    returns: "Liste {az, gericht, date, snippet}",
    action_id: "act_http_caselaw",
    used_by_agent_ids: ["legal_review"],
    calls_24h: 940,
    success: 0.987,
  },
  {
    id: "tool_lookup_paragraph",
    slug: "lookup_paragraph",
    name: "Paragraph nachschlagen",
    description: "Liefert Wortlaut und letzte \u00c4nderung eines BGB-/HGB-Paragraphen.",
    category: "Recht",
    version: "v1.0",
    status: "stable",
    params: { paragraph: "string" },
    returns: "{text, last_amended}",
    action_id: "act_sql_paragraph",
    used_by_agent_ids: ["legal_review"],
    calls_24h: 720,
    success: 0.999,
  },
  {
    id: "tool_compute_ratios",
    slug: "compute_ratios",
    name: "Kennzahlen berechnen",
    description: "Wirtschaftliche Kennzahlen aus Bilanz-CSV (current_ratio, debt_to_equity \u2026).",
    category: "Finanzen",
    version: "v0.9",
    status: "beta",
    params: { financials_csv: "string" },
    returns: "{ratios:{...}}",
    action_id: "act_worker_ratios",
    used_by_agent_ids: ["financial_audit"],
    calls_24h: 280,
    success: 0.94,
  },
  {
    id: "tool_benchmark_industry",
    slug: "benchmark_industry",
    name: "Branchen-Benchmark",
    description: "Vergleicht Kennzahlen mit Branchenbenchmark-Index.",
    category: "Finanzen",
    version: "v1.1",
    status: "stable",
    params: { ratios: "object", branche: "string" },
    returns: "{percentile, peers}",
    action_id: "act_http_bench",
    used_by_agent_ids: ["financial_audit"],
    calls_24h: 110,
    success: 0.97,
  },
  {
    id: "tool_vector_search",
    slug: "vector_search",
    name: "Vektor-Suche",
    description:
      "Semantische Suche im KB-Vektorindex mit Top-K und Score-Threshold.",
    category: "Cross",
    version: "v2.0",
    status: "stable",
    params: { query: "string", k: "int=5" },
    returns: "Liste {chunk_id, text, score}",
    action_id: "act_http_vector",
    used_by_agent_ids: ["knowledge_answer"],
    calls_24h: 17800,
    success: 0.998,
  },
  {
    id: "tool_fetch_doc",
    slug: "fetch_doc",
    name: "Doc-Abruf",
    description: "L\u00e4dt ein Dokument per file_key aus der Dateiablage.",
    category: "Cross",
    version: "v1.0",
    status: "stable",
    params: { file_key: "string" },
    returns: "{mime, bytes_b64}",
    action_id: "act_files_get",
    used_by_agent_ids: ["knowledge_answer", "contract_bundle"],
    calls_24h: 1200,
    success: 0.999,
  },
  {
    id: "tool_pii_detect",
    slug: "pii_detect",
    name: "PII erkennen",
    description: "Erkennt PII-Spans (Name, IBAN, Adresse, E-Mail) in Text.",
    category: "Compliance",
    version: "v1.2",
    status: "stable",
    params: { text: "string", locale: "string" },
    returns: "{spans:[{type,start,end}]}",
    action_id: "act_worker_pii",
    used_by_agent_ids: ["pii_redactor"],
    calls_24h: 41000,
    success: 0.999,
  },
  {
    id: "tool_delegate_legal",
    slug: "delegate_legal_review",
    name: "Sub-Agent: Legal Review",
    description: "Delegiert eine Teilaufgabe an den legal_review Agent (A2A).",
    category: "Cross",
    version: "v0.5",
    status: "draft",
    params: { document_text: "string", jurisdiction: "string" },
    returns: "Antwort des Sub-Agents",
    action_id: "act_a2a_legal",
    used_by_agent_ids: ["contract_bundle"],
    calls_24h: 60,
    success: 0.93,
  },
];

/** Actions (Umsetzung) hinter den Tools: was wirklich ausgef\u00fchrt wird. Mockup. */
export const ACTIONS = [
  {
    id: "act_http_caselaw",
    name: "HTTP Caselaw API",
    kind: "http",
    target: "https://caselaw.intern.aimafia.de/v1/search",
    sandbox: false,
    timeout_ms: 4000,
    retries: 2,
    owner: "Hassan",
    status: "live",
    success_pct: 99.1,
    last_run: "vor 8s",
    exposed_via_tool_count: 1,
    data_store_ids: ["ds_vector_caselaw"],
    policy:
      "Nur GET. Read-only Scope. Antworten werden 24h im Cache gehalten.",
  },
  {
    id: "act_sql_paragraph",
    name: "SQL paragraph_lookup",
    kind: "sql",
    target: "telephonio.modules_paragraphs",
    sandbox: false,
    timeout_ms: 800,
    retries: 1,
    owner: "Hassan",
    status: "live",
    success_pct: 99.9,
    last_run: "vor 2m",
    exposed_via_tool_count: 1,
    data_store_ids: ["ds_mysql_telephonio"],
    policy: "Nur SELECT auf paragraphs/jurisdictions. Allowlist im Backend.",
  },
  {
    id: "act_worker_ratios",
    name: "Python-Worker Ratios",
    kind: "worker",
    target: "queue:agent_workers/ratios",
    sandbox: true,
    timeout_ms: 12000,
    retries: 1,
    owner: "Masih",
    status: "live",
    success_pct: 94.2,
    last_run: "vor 6m",
    exposed_via_tool_count: 1,
    data_store_ids: [],
    policy: "Sandbox-Container, kein Netz au\u00dfer Allowlist (api.bench.de).",
  },
  {
    id: "act_http_bench",
    name: "HTTP Benchmark Provider",
    kind: "http",
    target: "https://api.bench-de.com/v2/peers",
    sandbox: false,
    timeout_ms: 5000,
    retries: 2,
    owner: "Masih",
    status: "live",
    success_pct: 97.4,
    last_run: "vor 14m",
    exposed_via_tool_count: 1,
    data_store_ids: [],
    policy: "API-Key in Vault, Quota 5k/Tag. Keine PII rausgeben.",
  },
  {
    id: "act_http_vector",
    name: "Qdrant Vector Search",
    kind: "http",
    target: "https://vectors.aimafia.de/collections/kb/points/search",
    sandbox: false,
    timeout_ms: 1500,
    retries: 0,
    owner: "Elias",
    status: "live",
    success_pct: 99.8,
    last_run: "vor 1s",
    exposed_via_tool_count: 1,
    data_store_ids: ["ds_vector_kb"],
    policy: "Nur Lese-Scope. Top-K \u2264 25. Embeddings serverseitig.",
  },
  {
    id: "act_files_get",
    name: "Files Get (uploads/)",
    kind: "files",
    target: "backend/uploads/{file_key}",
    sandbox: false,
    timeout_ms: 2000,
    retries: 1,
    owner: "Hassan",
    status: "live",
    success_pct: 99.9,
    last_run: "vor 30s",
    exposed_via_tool_count: 1,
    data_store_ids: ["ds_files_uploads"],
    policy: "Owner-Check via JWT. Nicht in Logs spiegeln.",
  },
  {
    id: "act_worker_pii",
    name: "PII-Worker",
    kind: "worker",
    target: "queue:agent_workers/pii",
    sandbox: true,
    timeout_ms: 700,
    retries: 0,
    owner: "Hassan",
    status: "live",
    success_pct: 99.95,
    last_run: "vor 4s",
    exposed_via_tool_count: 1,
    data_store_ids: ["ds_vector_pii_patterns"],
    policy: "Kein Persistieren des Inputs. Nur PII-Map zur\u00fcckgeben.",
  },
  {
    id: "act_a2a_legal",
    name: "A2A: legal_review",
    kind: "a2a",
    target: "https://ws.aimafia.de/api/agent/a2a/legal_review",
    sandbox: false,
    timeout_ms: 15000,
    retries: 0,
    owner: "Hassan",
    status: "maintenance",
    success_pct: 92.8,
    last_run: "vor 1h",
    exposed_via_tool_count: 1,
    data_store_ids: [],
    policy:
      "Nur Sub-Agent-Aufrufe \u00fcber a2a-Protokoll. Cost-Cap 0,30 \u20ac / Aufruf.",
  },
];

/** Data (Datenhaltung): Speicher und Indizes. Mockup. */
export const DATA_STORES = [
  {
    id: "ds_mysql_telephonio",
    name: "MySQL telephonio",
    kind: "mysql",
    location: "ec2://db.aimafia.de:3306/telephonio",
    size_label: "2.4 GB",
    rows_label: "\u2248 1.6 Mio Zeilen",
    retention_days: 1095,
    scope: "global",
    last_index: "live",
    used_by_action_ids: ["act_sql_paragraph"],
    policy:
      "Backups t\u00e4glich. Personenbezogene Felder pseudonymisiert in Logs.",
  },
  {
    id: "ds_files_uploads",
    name: "Uploads (backend/uploads)",
    kind: "files",
    location: "ec2:/var/www/phone-marketplace/backend/uploads",
    size_label: "18 GB",
    rows_label: "12.400 Dateien",
    retention_days: 365,
    scope: "per_tenant",
    last_index: "live",
    used_by_action_ids: ["act_files_get"],
    policy: "Zugriff nur \u00fcber file_key + JWT-Owner-Check.",
  },
  {
    id: "ds_vector_caselaw",
    name: "Qdrant: Caselaw",
    kind: "vector",
    location: "qdrant://vectors.aimafia.de/caselaw",
    size_label: "1.1 GB",
    rows_label: "12.400 Chunks",
    retention_days: 730,
    scope: "global",
    last_index: "2026-04-28 08:00",
    used_by_action_ids: ["act_http_caselaw"],
    policy: "Read-only f\u00fcr Tools. Reindex w\u00f6chentlich (Sonntag 04:00).",
  },
  {
    id: "ds_vector_kb",
    name: "Qdrant: Knowledge-Base",
    kind: "vector",
    location: "qdrant://vectors.aimafia.de/kb",
    size_label: "6.7 GB",
    rows_label: "89.000 Chunks",
    retention_days: 365,
    scope: "global",
    last_index: "2026-04-28 06:00",
    used_by_action_ids: ["act_http_vector"],
    policy: "Reindex t\u00e4glich aus Doc-Pipeline.",
  },
  {
    id: "ds_vector_pii_patterns",
    name: "Vector: PII-Patterns",
    kind: "vector",
    location: "qdrant://vectors.aimafia.de/pii_patterns",
    size_label: "120 MB",
    rows_label: "8.900 Patterns",
    retention_days: 0,
    scope: "global",
    last_index: "2026-04-25 09:00",
    used_by_action_ids: ["act_worker_pii"],
    policy: "Kein Speichern von Input-Text. Nur Pattern-Match-Scores.",
  },
  {
    id: "ds_cache_caselaw",
    name: "Cache: Caselaw 24h",
    kind: "cache",
    location: "redis://cache.aimafia.de/0",
    size_label: "320 MB",
    rows_label: "\u2248 18k Schl\u00fcssel",
    retention_days: 1,
    scope: "global",
    last_index: "live",
    used_by_action_ids: ["act_http_caselaw"],
    policy: "TTL 24h. Keine PII in Schl\u00fcssel.",
  },
];
